export const CONFIGURATION = {
  name: "hAIr",
  title: "hAIr - AI-Powered Hairstyle Preview",
  description: {
    short: "See how you look with different haircuts using AI",
    long: "Visualize new hairstyles on yourself with advanced AI technology. Discover your perfect look before committing to a change.",
  },
  mail: {
    contact: "contact@closeby.tel",
    noreply: "noreply@closeby.tel",
    support: "support@closeby.tel",
  },
  pages: {
    about: {
      title: "About",
      description: "Learn more about the mission behind hAIr",
      content: `hAIr is an AI-powered hairstyle preview platform focused on **speed**, **clarity**, and **privacy-first design**.

## What We Do
- Visualize how you look with different haircuts using advanced AI technology.
- Explore new hairstyles before committing to a change.
- Keep the process simple and fast.

## Principles
1. Respect your time.
2. Prefer simple, reliable technology.
3. Ship small, iterate fast.

## Contact
Have feedback? Reach out anytime: [support@closeby.tel](mailto:support@closeby.tel)`,
    },
    help: {
      title: "Help",
      description: "Help center and common FAQs",
      content: `Welcome to the hAIr help center. This page covers quick tips and a short FAQ.

## Getting Started
- Browse the Pages section for About, Terms, and Privacy.
- Reach out anytime at [contact@closeby.tel](mailto:contact@closeby.tel). Please consider checking your SPAM folder if you don't see a reply.

## FAQ
### What is hAIr?
hAIr is an AI-powered platform that lets you visualize how you would look with different haircuts and hairstyles before making a change.

### How do I use hAIr?
Simply upload a photo of yourself, and our AI will generate previews of various hairstyles applied to your image.

### How do I contact support?
Email us at [support@closeby.tel](mailto:support@closeby.tel). We typically reply within 1-2 business days. Please consider checking your SPAM folder if you don't see a reply.

### Do you store my data?
We keep data minimal and necessary for operation. See the Privacy Policy for details.

### Can I request a feature?
Yes! Send your suggestion to [contact@closeby.tel](mailto:contact@closeby.tel) with as much detail as you can. Please consider checking your SPAM folder if you don't see a reply.`,
    },
    contact: {
      title: "Contact",
      description: "How to reach the hAIr team",
      content: `We'd love to hear from you.

## Email
- General inquiries: [contact@closeby.tel](mailto:contact@closeby.tel)
- Support inquiries: [support@closeby.tel](mailto:support@closeby.tel)

Please consider checking your SPAM folder if you don't see a reply.

## When to reach out
- Questions about features or roadmap
- Reporting bugs or security concerns
- Feedback and suggestions

## Response time
We typically respond within 1-2 business days.`,
    },
    termsOfService: {
      title: "Terms of Service",
      description: "Rules and conditions for using hAIr",
      content: `These Terms govern your use of hAIr.

## 1. Acceptance
By accessing or using the service you agree to these Terms.

## 2. Use
You agree not to abuse, overload, or attempt to breach security of the platform.

## 3. Subscription
Paid features require an active subscription; billing cycles and refunds are handled via Stripe.

## 4. Limitation of Liability
Service is provided *as-is* with no warranties.

## 5. Changes
We may update these Terms; continued use after changes constitutes acceptance.

## 6. Contact
Questions? Email [contact@closeby.tel](mailto:contact@closeby.tel). Please consider checking your SPAM folder if you don't see a reply.`,
    },
    privacyPolicy: {
      title: "Privacy Policy",
      description: "How we collect, use, and protect your data",
      content: `Last updated: ${new Date().toLocaleDateString()}

We take your privacy seriously. This page outlines what we collect and how we use it.

## Data We Collect
- Account details you provide (name, email, phone).
- Usage events necessary to operate the service.

## How We Use Data
- To provide, maintain, and improve hAIr.
- To communicate important updates related to your account.

## Data Sharing
We do **not** sell your data. We only share with infrastructure providers strictly necessary to deliver the service.

## Your Choices
- You may request data export or deletion at any time by contacting support.

## Contact
Questions? Email [contact@closeby.tel](mailto:contact@closeby.tel). Please consider checking your SPAM folder if you don't see a reply.`,
    },
  },
};
